<div class="button-bar">
    @for (button of buttons; track button.label; let i = $index) {
    <button [class]="button.class" (click)="button.clickAction()" [id]="button.id">
        @if (button.icon) {
        <i-bs [name]="button.icon"></i-bs>
        }
        {{ button.label }}
    </button>
    }
</div>